import React, { useEffect } from "react";
import { Header } from "../components/Common/Header";
import { Title } from "../components/Common/Title";
import { PrimaryButton } from "../components/Common/PrimaryButton";
// import { ReactComponent as Quote } from "../assets/icons/quote.svg";
import { Link, useNavigate } from "react-router-dom";
// import { Parallex } from "../components/Common/Parallax";
// import { InfoCard } from "../components/Information/InfoCard";

import Book from "../assets/images/book-in-hands.webp";

import ICf1 from "../assets/images/two-happy-busy-middle-aged-600nw-2479065515.webp";
import ICf2 from "../assets/images/istockphoto-1308573996-612x612.jpg";

import { ReactComponent as Employeer } from "../assets/icons/employeer.svg";
import { ReactComponent as CorporateEmp } from "../assets/icons/corporate.svg";
import { ReactComponent as Businessman } from "../assets/icons/businessman.svg";
import { ReactComponent as Coach } from "../assets/icons/coach.svg";
import { ReactComponent as Parent } from "../assets/icons/parent.svg";



import BgImage from "../assets/images/Headers/Pathway.webp";
import InteractiveTestimonials from "../components/Testimonials/TestimonialCard";

export const Pathway = () => {
  const navigate = useNavigate();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <>
      <Header
        image={BgImage}
        title="ICF Certification Program"
      />
      <div>
        <div
          style={{
            width: "100%",
            justifyContent: "center",
            display: "flex",
            padding: "50px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "50px",
            }}
          >
            <div
              style={{
                flex: "1 1 300px",
                gap: "10px",
                display: "flex",
                flexDirection: "column",
                maxWidth: "100%",
              }}
            >
              <p
                style={{
                  fontSize: "16px",
                  textAlign: "left",
                  lineHeight: "1.6",
                }}
                data-aos="fade"
              >
                Introduction
              </p>
              <p
                style={{
                  fontSize: "40px",
                  textAlign: "left",
                  lineHeight: "1.2",
                }}
                data-aos="fade"
              >
                What is ICF Certification?
              </p>
              <p
                style={{
                  fontSize: "16px",
                  textAlign: "left",
                  lineHeight: "1.6",
                }}
                data-aos="fade"
              >
                The International Coaching Federation (ICF) is the world’s top
                organization for professional coaches. It trains and certifies
                people who want to help others reach their full potential. Being
                ICF certified means you are officially recognized as a skilled
                coach who follows high ethical standards.
              </p>
            </div>
            <div
              style={{
                flex: "1 1 300px",
                aspectRatio: "3 / 2",
              }}
              data-aos="fade"
            >
              <img
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                src={Book}
                alt="Coaching Federation Logo"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          width: "100%",
          justifyContent: "center",
          flexDirection: "column",
          display: "flex",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <Title subtitle={"Join Our Certification Programs"} center={true} />

        <div
          style={{
            marginTop: "30px",
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "50px",
          }}
        >
          {[
            {
              link: "/resource/icf-level-1",
              image: ICf1,
              title: "ICF Level I (ACC) Certification Program",
            },
            {
              link: "/resource/icf-level-2",
              image: ICf2,
              title: "ICF Level 2 (PCC) Certification Program",
            },
          ].map((item, index) => (
            <div
              style={{
                width: "calc(50% - 25px)",
                minWidth: "300px",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
              data-aos="fade"
            >
              <div
                style={{
                  width: "100%",
                  aspectRatio: "5/3",
                  borderRadius: "8px",
                  overflow: "hidden",
                  position: "relative",
                  backgroundColor: "black",
                }}
              >
                <Link
                  to={item.link}
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <img
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                    src={
                        item.image
                    }
                    alt={item.title}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.5)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "clamp(20px, 5vw, 40px)",
                        color: "white",
                        fontWeight: "bold",
                        textAlign: "center",
                        padding: "20px",
                        lineHeight: 1.4
                      }}
                    >
                      {item.title}
                    </span>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div
        style={{
          width: "100%",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <Title
          subtitle={"Who Benefits from Becoming an ICF-Certified Coach"}
          center={true}
        />
        <div
          style={{
            display: "flex",
            // justifyContent: "center",
            justifyContent: "space-evenly",
            flexWrap: "wrap",
            marginTop: "50px",
          }}
        >
          {[
            {
              id: 1,
              label: "Employers",
              icon: <Employeer width="100%" height="100%" />,
            },
            {
              id: 2,
              label: "Corporate Employees",
              icon: <CorporateEmp width="100%" height="100%" />,
            },
            {
              id: 3,
              label: "Entrepreneurs",
              icon: <Businessman width="100%" height="100%" />,
            },
            {
              id: 4,
              label: "Coaches",
              icon: <Coach width="100%" height="100%" />,
            },
            {
              id: 5,
              label: "Parents",
              icon: <Parent width="100%" height="100%" />,
            },
          ].map((item, index) => (
            <div key={item.id} style={{ width: "130px", marginBottom: "30px" }} data-aos={"fade"}>
              {/* <img
                src={item.icon}
                alt={item.label}
                style={{ width: "100%", marginBottom: "10px" }}
              /> */}
              {item.icon}
              <p
                style={{
                  fontSize: "18px",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                {item.label}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div>
        <div
          style={{
            width: "100%",
            justifyContent: "center",
            display: "flex",
            padding: "50px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "50px",
            }}
          >
            <div
              style={{
                flex: "1 1 300px",
                aspectRatio: "3 / 2",
              }}
              data-aos="fade"
            >
              <img
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                src={Book}
                alt="Coaching Federation Logo"
              />
            </div>
            <div
              style={{
                flex: "1 1 300px",
                gap: "10px",
                display: "flex",
                flexDirection: "column",
                maxWidth: "100%",
              }}
            >
              <p
                style={{
                  fontSize: "40px",
                  textAlign: "left",
                  lineHeight: "1.2",
                }}
                data-aos="fade"
              >
                Why Now?
              </p>
              <p
                style={{
                  fontSize: "16px",
                  textAlign: "left",
                  lineHeight: "1.6",
                }}
                data-aos="fade"
              >
                Coaching is one of the fastest-growing careers in the world.
                With 59,627 ICF-certified coaches in 158 countries, the demand
                for skilled, certified coaches is rising. It’s your chance to be
                part of this exciting, high-impact field.
              </p>
              <div style={{ marginTop: "20px" }}>
                <PrimaryButton
                  label={"Learn More"}
                  onClick={() => {
                    navigate(`/facts`);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div
          style={{
            width: "100%",
            justifyContent: "center",
            display: "flex",
            padding: "50px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "50px",
            }}
          >
            <div
              style={{
                flex: "1 1 300px",
                gap: "10px",
                display: "flex",
                flexDirection: "column",
                maxWidth: "100%",
              }}
            >
              <p
                style={{
                  fontSize: "40px",
                  textAlign: "left",
                  lineHeight: "1.2",
                }}
                data-aos="fade"
              >
                Ready to Start?
              </p>
              <p
                style={{
                  fontSize: "16px",
                  textAlign: "left",
                  lineHeight: "1.6",
                }}
                data-aos="fade"
              >
                Don’t wait. The world needs more skilled coaches. Become one
                today and take control of your future. Join thousands of coaches
                worldwide who are changing lives, including their own.
                <br />
                <br />
                Click below to get started now!
              </p>
              <div style={{ marginTop: "20px" }}>
                <PrimaryButton label={"Sign Up"} onClick={()=>{
                  window.open("https://wa.me/9819926379?text=I%20would%20like%20to%20know%20more%20about%20coaching%20programs", "_blank");
                }} />
              </div>
            </div>
            <div
              style={{
                flex: "1 1 300px",
                aspectRatio: "3 / 2",
              }}
              data-aos="fade"
            >
              <img
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                src={Book}
                alt="Coaching Federation Logo"
              />
            </div>
          </div>
        </div>
      </div>

      {/* <div
        style={{
          padding: "80px 20px",
          display: "flex",
          flexDirection: "column",
          gap: "50px",
        }}
      >
        <Title center={true} subtitle="What Our Coaches Say" /> */}

        {/* <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "30px",
            flexWrap: "wrap",
            overflow: "visible",
          }}
        >
          {[
            {
              image:
                "https://i.pinimg.com/originals/87/14/55/8714556a52021ba3a55c8e7a3547d28c.png",
              name: "Sanjay, ICF-Certified Coach",
              caption:
                "Getting my ICF certification changed my life! I’m now working with clients all over the world and have the flexibility to work from anywhere. Plus, I’m helping people grow every day",
            },
            {
              image:
                "https://i.pinimg.com/originals/87/14/55/8714556a52021ba3a55c8e7a3547d28c.png",
              name: "Priya, Entrepreneur and Coach",
              caption:
                "As an entrepreneur, becoming an ICF-certified coach gave me the leadership skills I needed to grow my business. It also opened up new opportunities with clients from across the globe.",
            },
            {
              image:
                "https://i.pinimg.com/originals/87/14/55/8714556a52021ba3a55c8e7a3547d28c.png",
              name: "S. Venkatakrishnan",
              caption:
                "As an entrepreneur, becoming an ICF-certified coach gave me the leadership skills I needed to grow my business. It also opened up new opportunities with clients from across the globe.",
            },
          ].map((testimonial, index) => (
              <TestimonialCard
                key={index}
                image={testimonial.image}
                name={testimonial.name}
                caption={testimonial.caption}
              />
          ))}
        </div> */}
      {/* </div> */}

      <div
        style={{
          padding: "50px",
          display: "flex",
          flexDirection: "column",
          gap: "50px",
        }}
      >
        <InteractiveTestimonials />
      </div>
    </>
  );
};
